const BLACKLIST = [
  '00000000000',
  '11111111111',
  '22222222222',
  '33333333333',
  '44444444444',
  '55555555555',
  '66666666666',
  '77777777777',
  '88888888888',
  '99999999999',
]

/**
 * Check if string is a CPF valid.
 * @param { String } value - is a String to check if a CPF valid.
 * @return { Boolean } is a valid cpf
 */
const cpf = (v) => {
  const value = v.replace(/[^\d]+/g, '')

  if (value === '') return false

  // Elimina CPFs invalidos conhecidos
  if (value.length !== 11 || BLACKLIST.includes(value)) {
    return false
  }

  // Valida 1° digito
  let rev
  let add = 0
  for (let i = 0; i < 9; i += 1) {
    add += parseInt(value.charAt(i), 10) * (10 - i)
  }
  rev = 11 - (add % 11)
  if (rev === 10 || rev === 11) {
    rev = 0
  }
  if (rev !== parseInt(value.charAt(9), 10)) {
    return false
  }

  // Valida 2° digito
  add = 0
  for (let i = 0; i < 10; i += 1) {
    add += parseInt(value.charAt(i), 10) * (11 - i)
  }
  rev = 11 - (add % 11)
  if (rev === 10 || rev === 11) {
    rev = 0
  }
  if (rev !== parseInt(value.charAt(10), 10)) {
    return false
  }

  return true
}

export { cpf }
export default cpf
